module.exports = __webpack_public_path__ + "img/mysql.51cbaa0d.svg";